import { TFunction } from '@mint-lib/i18n';
import z from 'zod';

export const FlowTypesEnum = z.enum(['flight']);
export const EntityTypesEnum = z.enum(['user', 'role']);
export const OperationTypesEnum = z.enum(['and', 'or', 'then']);
export const GroupStatusesEnum = z.enum([
  'draft',
  'pending',
  'approved',
  'rejected',
]);
export const ApprovalProcessStatusesEnum = z.enum([
  'draft',
  'pending',
  'approved',
  'rejected',
]);
export const EntityStatusesEnum = z.enum(['stranger', 'requester', 'approver']);

export type FlowTypes = z.infer<typeof FlowTypesEnum>;
export type EntityTypes = z.infer<typeof EntityTypesEnum>;
export type OperationTypes = z.infer<typeof OperationTypesEnum>;
export type GroupStatuses = z.infer<typeof GroupStatusesEnum>;
export type ApprovalProcessStatuses = z.infer<
  typeof ApprovalProcessStatusesEnum
>;
export type EntityStatuses = z.infer<typeof EntityStatusesEnum>;

export const getMapLabelByFlowType = (
  t: TFunction,
): Record<FlowTypes, string> => {
  return {
    [FlowTypesEnum.enum.flight]: t('Flight'),
  };
};

export const getMapLabelByOperationType = (
  t: TFunction,
): Record<OperationTypes, string> => {
  return {
    [OperationTypesEnum.enum.and]: t('And'),
    [OperationTypesEnum.enum.or]: t('Or'),
    [OperationTypesEnum.enum.then]: t('Then'),
  };
};

export const getMapLabelByGroupStatus = (
  t: TFunction,
): Record<GroupStatuses, string> => {
  return {
    [GroupStatusesEnum.enum.draft]: t('Draft'),
    [GroupStatusesEnum.enum.pending]: t('Pending'),
    [GroupStatusesEnum.enum.approved]: t('Approved'),
    [GroupStatusesEnum.enum.rejected]: t('Rejected'),
  };
};

export const mapChipPropsByGroupStatus = {
  [GroupStatusesEnum.enum.draft]: {
    variant: 'outline',
    size: 'medium',
    color: 'silver',
  },
  [GroupStatusesEnum.enum.pending]: {
    variant: 'outline',
    size: 'medium',
    color: 'info',
  },
  [GroupStatusesEnum.enum.rejected]: {
    variant: 'outline',
    size: 'medium',
    color: 'error',
  },
  [GroupStatusesEnum.enum.approved]: {
    variant: 'outline',
    size: 'medium',
    color: 'success',
  },
} as const;
